import { useQuery } from '@tanstack/react-query';

import MerchandisingCollectionsService from '@/services/MerchandisingCollectionsService';

export const MERCHANDISING_COLLECTION_QUERY_KEY = ['merchandisingCollection'];

export function useGetMerchandisingCollection(id: number) {
  const { data, isFetching, isError } = useQuery({
    queryKey: [...MERCHANDISING_COLLECTION_QUERY_KEY, id],
    enabled: !!id,
    queryFn: () => MerchandisingCollectionsService.findCollection(id),
  });

  return {
    merchandisingCollection: data,
    isLoading: isFetching,
    isError,
  };
}
